import { render, staticRenderFns } from "./room-config.vue?vue&type=template&id=49639099&scoped=true"
import script from "./room-config.vue?vue&type=script&lang=js"
export * from "./room-config.vue?vue&type=script&lang=js"
import style0 from "./room-config.vue?vue&type=style&index=0&id=49639099&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49639099",
  null
  
)

export default component.exports